import styled from 'styled-components'
import { textAnim, yellowDivOpa, whiteDivOpa } from './animations'

interface sectionProps {
  border?: boolean
  width?: string
  evenly?: boolean
}
export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 315px;
  height: 607px;
`
export const Section = styled.section<sectionProps>`
  position: relative;
  display: flex;
  justify-content: space-between;
  justify-content: ${({ evenly }) =>
    evenly ? 'space-evenly;' : 'space-between;'};
  align-items: center;
  text-transform: uppercase;
  height: 56px;
  border: ${({ border }) => (border ? '3px solid #ffb000;' : 'none;')};
  width: ${({ width }) => width || '100%;'};
  border-radius: 28px;
  margin: 15px 0 20px 0;
  .infinite {
    position: absolute;
    height: 48px;
    width: 20px;
    left: 25px;
    pointer-events: none;
  }
`

export const StakeSection = styled.section`
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 56.69%; */
  width: 178px;
  height: 56px;
  border-radius: 38px;
  border: solid 3px#ffb000;
  input {
    font-size: 10px;
    text-align: center;
    height: 40px;
    width: 100px;
    color: #ffb000;
    background: transparent;
    outline: none;
    border: none;
  }
`

interface IncResBtn {
  increase?: boolean
  active: boolean
}
export const Wrapper = styled.div<IncResBtn>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ increase }) => (increase ? '41.44%' : '25.25%')};
  height: 72%;
  border-radius: 18px;
  font-size: 12px;
  border: solid 3px #ffb000;
  cursor: pointer;
  animation: ${p => (p.active ? textAnim : null)};
  .yellow {
    position: absolute;
    width: 106%;
    height: 106%;
    border-radius: 18px;
    background: #ffb000;
    opacity: 0;
    animation: ${p => (p.active ? yellowDivOpa : null)};
  }
  .white {
    position: absolute;
    width: 106%;
    height: 106%;
    border-radius: 18px;
    background: #ffffff;
    opacity: 0;
    animation: ${p => (p.active ? whiteDivOpa : null)};
  }
  p {
    z-index: 1;
  }
`

export const p = {
  textAlign: 'center' as const,
  fontSize: 20,
  cursor: 'pointer',
}
